import { Tooltip } from 'antd';
import classNames from 'classnames';

import { TOOLTIP_PLACEMENT, UNIT_MEASURE } from '@common/constants';
import cssColors from '@common/css/cssColors.module.scss';
import formatUOM from '@common/helpers/formatUOM';
import { getOnTrendLabelFromProduct } from '@common/helpers/onTrendLabel';
import { ApplianceModel, ApplianceType } from '@common/models';
import { getProductDescription } from '@common/utils';
import { formatPriceUnitOrFree } from '@common/utils/formatPriceUnitOrFree';
import ApplianceDragableImage from '@core/components/ApplianceDragableImage/ApplianceDragableImage';
import InstructionsBanner from '@core/components/instructions-banner/InstructionsBanner';
import ImageUtils from '@core/utils/ImageUtils';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { selectSelectedRefrigeratorId, updateSelectedRefrigeratorId } from '@redux/slices/refrigeratorSlice';

interface RefrigeratorItemProps {
    refrigerator: ApplianceModel;
}

export const RefrigeratorItem = ({ refrigerator }: RefrigeratorItemProps) => {
    const description = getProductDescription(refrigerator);
    const dispatch = useAppDispatch();
    const selectedRefrigeratorId = useAppSelector(selectSelectedRefrigeratorId);

    const onTrendLabel = getOnTrendLabelFromProduct(refrigerator);

    const isSelected = refrigerator.productId === selectedRefrigeratorId;
    const unitOfMeasure = formatUOM(refrigerator.unitOfMeasure || UNIT_MEASURE.REFRIGERATOR);

    const clonedRefrigerator = {
        ...refrigerator,
        applianceType: ApplianceType.REFRIGERATOR,
    };

    return (
        <div
            className={classNames('card-option', { selected: isSelected })}
            onMouseUp={() => {
                dispatch(updateSelectedRefrigeratorId(refrigerator.productId));
            }}
        >
            {onTrendLabel && <div className="on-trend">{onTrendLabel}</div>}
            <ApplianceDragableImage
                alt="refrigerator"
                className="card-option__image"
                src={ImageUtils.imgUrl(refrigerator.beautyShotImageUrl ?? refrigerator.imageUrl, 300)}
                applianceModel={clonedRefrigerator}
            />
            <InstructionsBanner className="card-option__banner" hidden={!isSelected} />
            <Tooltip title={description} color={cssColors.toolTipColor} placement={TOOLTIP_PLACEMENT}>
                <div className="name">{description}</div>
            </Tooltip>
            <div className="price">{formatPriceUnitOrFree(refrigerator.price, unitOfMeasure)}</div>
        </div>
    );
};
